/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMetierClauseGridDto } from './FcbMetierClauseGridDto';
import {
    FcbMetierClauseGridDtoFromJSON,
    FcbMetierClauseGridDtoFromJSONTyped,
    FcbMetierClauseGridDtoToJSON,
} from './FcbMetierClauseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMetierClauseGridDtoPaginatedResults
 */
export interface FcbMetierClauseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierClauseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMetierClauseGridDto>}
     * @memberof FcbMetierClauseGridDtoPaginatedResults
     */
    results?: Array<FcbMetierClauseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMetierClauseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMetierClauseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMetierClauseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierClauseGridDtoPaginatedResultsFromJSON(json: any): FcbMetierClauseGridDtoPaginatedResults {
    return FcbMetierClauseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMetierClauseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierClauseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMetierClauseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMetierClauseGridDtoPaginatedResultsToJSON(value?: FcbMetierClauseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMetierClauseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

